import { useEffect, useState } from 'react';

const MOBILE_SCREEN_WIDTH = 500;
const TABLET_SCREEN_WIDTH = 1024;
const DESKTOP_SCREEN_WIDTH = 1920;

const DEVICE_TYPES = {
    WEB: 'web',
    MOBILE: 'mobile',
    TABLET: 'tablet',
    LIVING_ROOM: 'livingRoom',
    DEFAULT: 'default',
};

/**
 * The function `useDeviceResolution` dynamically determines the device type based on the screen width
 * and returns the device type along with the current screen width.
 * @returns The `useDeviceResolution` function returns an object with two properties: `device` and
 * `screenWidth`. The `device` property represents the type of device based on the screen width, and
 * the `screenWidth` property represents the current width of the window.
 */
function useDeviceResolution() {
    const [device, setDevice] = useState('');
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const updateWindowWidth = () => {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener('resize', updateWindowWidth);
        return () => {
            window.removeEventListener('resize', updateWindowWidth);
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            if (screenWidth <= MOBILE_SCREEN_WIDTH) {
                setDevice(DEVICE_TYPES.MOBILE);
            } else if (
                screenWidth > MOBILE_SCREEN_WIDTH &&
                screenWidth <= TABLET_SCREEN_WIDTH
            ) {
                setDevice(DEVICE_TYPES.TABLET);
            } else if (
                screenWidth > TABLET_SCREEN_WIDTH &&
                screenWidth <= DESKTOP_SCREEN_WIDTH
            ) {
                setDevice(DEVICE_TYPES.WEB);
            } else if (screenWidth > DESKTOP_SCREEN_WIDTH) {
                setDevice(DEVICE_TYPES.LIVING_ROOM);
            } else {
                setDevice(DEVICE_TYPES.DEFAULT);
            }
        };
        handleResize();
    }, [screenWidth]);

    return { device, screenWidth };
}

export { useDeviceResolution as default, DEVICE_TYPES };
